import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";

const Global = createGlobalStyle`
  @import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #f0ebe3; font-family: 'Pretendard', sans-serif; }
`;
const Wrap = styled.div`min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;`;
const Card = styled.div`
  width:100%;max-width:440px;background:#fff;border:1.5px solid #e0d5c8;
  border-radius:20px;padding:48px 28px;text-align:center;
  box-shadow:0 4px 24px rgba(100,70,40,0.10);
`;
const Icon = styled.div`font-size:3rem;margin-bottom:12px;`;
const Title = styled.h2`font-size:1.2rem;color:#3d2b1f;font-weight:800;margin-bottom:8px;`;
const Desc = styled.p`font-size:0.85rem;color:#7a6654;line-height:1.7;margin-bottom:20px;`;
const Btn = styled.button`
  padding:12px 28px;background:#c09a6b;color:#fff;border:none;
  border-radius:24px;font-size:0.9rem;font-weight:700;cursor:pointer;font-family:inherit;
`;

export default function PaymentFailPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const msg = params.get("message") || "결제가 취소되었거나 실패했습니다.";

  return (
    <>
      <Global />
      <Wrap>
        <Card>
          <Icon>😔</Icon>
          <Title>결제 실패</Title>
          <Desc>{msg}<br />다시 시도하시거나 다른 결제 수단을 이용해 주세요.</Desc>
          <Btn onClick={() => navigate("/client")}>돌아가기</Btn>
        </Card>
      </Wrap>
    </>
  );
}
